import { render, staticRenderFns } from "./FeatureTile.vue?vue&type=template&id=1d38fa06&scoped=true"
import script from "./FeatureTile.vue?vue&type=script&lang=js"
export * from "./FeatureTile.vue?vue&type=script&lang=js"
import style0 from "./FeatureTile.vue?vue&type=style&index=0&id=1d38fa06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38fa06",
  null
  
)

export default component.exports